import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import UserService from "../services/user.service"; // Assuming UserService handles API calls
import { Alert, Table, Container, Form, Pagination, Spinner, Button, Modal } from 'react-bootstrap';
import { LoadScript, GoogleMap, Marker, Autocomplete, InfoWindow } from '@react-google-maps/api';

import { FaCheckCircle } from 'react-icons/fa'; // Ensure you have react-icons installed
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';

const batchURI= process.env.REACT_APP_API_BATCH_URL;
const libraries = ["places"];

function formatDeDate(value) {
  if (!value) return '–';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '–';
  return date.toLocaleDateString('de-DE');
}

function googleReviewUrl(code) {
  const stored = String(code.service_out_url_with_place_id || '').trim();
  if (stored && /^https?:\/\//i.test(stored)) return stored;
  const placeId = String(code.place_id || '').trim();
  const prefix = String(code.service_out_url || '').trim();
  if (!prefix || !placeId || !/^https?:\/\//i.test(prefix)) return '';
  if (prefix.includes(placeId)) return prefix;
  if (prefix.endsWith('=') || prefix.endsWith('/') || prefix.endsWith('?')) return `${prefix}${placeId}`;
  return `${prefix.replace(/\/+$/, '')}/${placeId}`;
}

function SearchableFilter({ label, value, onChange, options, placeholder }) {
  const [query, setQuery] = useState('');
  const needle = query.trim().toLowerCase();
  const visible = options.filter((option) => {
    if (!needle) return true;
    return option.label.toLowerCase().includes(needle) || String(option.value) === String(value);
  });

  return (
    <Form.Group className="mb-0" style={{ flex: '1 1 220px', minWidth: 200 }}>
      <Form.Label className="mb-1">{label}</Form.Label>
      <Form.Control
        type="search"
        value={query}
        placeholder={placeholder}
        onChange={(e) => setQuery(e.target.value)}
        aria-label={`${label} durchsuchen`}
        style={{ minHeight: 44 }}
      />
      <Form.Select
        className="mt-1"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-label={`${label} auswählen`}
        style={{ minHeight: 44 }}
      >
        <option value="">Alle</option>
        {visible.map((option) => (
          <option key={option.value} value={option.value}>{option.label}</option>
        ))}
      </Form.Select>
    </Form.Group>
  );
}

const BatchCodeManager = () => {
  const navigate = useNavigate();
  const [tariffs, setTariffs] = useState([]);
  const [batchCodes, setBatchCodes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [apiErrors, setApiErrors] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [batchNameFilter, setBatchNameFilter] = useState('');
  const [buyerFilter, setBuyerFilter] = useState('');
  const [sellerFilter, setSellerFilter] = useState('');
  const [filterOptions, setFilterOptions] = useState({ batchNames: [], buyers: [], sellers: [] });
  const [sortField, setSortField] = useState('batch_code_id');
  const [sortOrder, setSortOrder] = useState('asc');
  const [selectedBatchCodes, setSelectedBatchCodes] = useState([]); // To keep track of selected batch codes
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [formData, setFormData] = useState({
    place_id: '',
    service_id: '',
    place_name: '',
    place_address: '',
    latitude: '',
    longitude: '',
    tariff_id: 0,
  });
  const DEFAULT_LOCATION = { lat: 50.9375, lng: 6.9603 }; // Coordinates for Cologne
  const [map, setMap] = useState(null);
  const [autocomplete, setAutocomplete] = useState(null);
  const [placeInfo, setPlaceInfo] = useState({
    placeId: "",
    name: "",
    address: "",
  });
  const [errors, setErrors] = useState({});
  const [places, setPlaces] = useState([]); // List of places
  const [customers, setCustomers] = useState([]); // List of customers
  const [selectedCustomerId, setSelectedCustomerId] = useState(''); // Selected customer ID
  const [selectedTariffId, setSelectedTariffId] = useState(''); // Selected customer ID
  
  const [markerPosition, setMarkerPosition] = useState(DEFAULT_LOCATION); // For Google Maps marker
  const [isInfoWindowOpen, setIsInfoWindowOpen] = useState(false);
 
  const inputRef = useRef(null);
  const apiKey = "AIzaSyDzLGEYu_8RPpFgtQZdhi9xS2HkGGUsb-k";
const mapContainerStyle = {
  height: "400px",
  width: "100%",
};



const inputStyles = {
  boxSizing: "border-box",
                border: "1px solid transparent",
                width: "240px",
                height: "32px",
                padding: "0 12px",
                borderRadius: "3px",
                boxShadow: "0 2px 6px rgba(0, 0, 0, 0.3)",
                fontSize: "14px",
                outline: "none",
                textOverflow: "ellipses",
};
const [googleMapsLoaded, setGoogleMapsLoaded] = useState(false); // State to track if Google Maps is loaded

useEffect(() => {
  if (window.google) {
    setGoogleMapsLoaded(true); // Set state when Google Maps API is available
  }
}, []);

  // Load the batch codes, places, and customers from the backend
  useEffect(() => {
    loadBatchCodes();
    loadTariffs();
    //loadPlaces(); // Fetch places when the component mounts
    loadCustomers(); // Fetch customers when the component mounts
  }, [currentPage, searchTerm, sortField, sortOrder, batchNameFilter, buyerFilter, sellerFilter]);


  const loadTariffs = async () => {
    setApiErrors('');
    setLoading(true);
    try {
      const responsetariff=await UserService.getTariffBoardADM();
      setTariffs(responsetariff.data.tariffs);
      
    } catch (error) {
      setApiErrors('Charge-Tarife konnten nicht geladen werden');
    } finally {
      setLoading(false);
      
    }
  };

  const loadBatchCodes = async () => {
    setApiErrors('');
    setLoading(true);
    try {
      // Die Parameter werden jetzt im Body gesendet, wie es das Backend erwartet
      const response = await UserService.getADMBatchOrders({
        page: currentPage,
        limit: 10, // Sie können hier die Standard-Seitengröße festlegen
        search: searchTerm,
        sortBy: sortField,
        order: sortOrder,
        batchName: batchNameFilter,
        buyerIdFilter: buyerFilter,
        sellerIdFilter: sellerFilter,
      });
      
      // Da das Backend jetzt direkt die Codes liefert, ist flatMap nicht mehr nötig.
      setBatchCodes(response.data.batchOrders || []); 
      setTotalPages(response.data.totalPages || 1);
      if (response.data.filters) {
        setFilterOptions(response.data.filters);
      }

    } catch (error) {
      setApiErrors('Chargecodes konnten nicht geladen werden');
    } finally {
      setLoading(false);
    }
  };

  /*
  const loadPlaces = async () => {
    setApiErrors('');
    setLoading(true);
    try {
      const response = await UserService.getPlaces(); // Replace with your API call to fetch places
      setPlaces(response.data); // Assuming response.data contains an array of places
    } catch (error) {
      setApiErrors('Orte konnten nicht geladen werden');
    } finally {
      setLoading(false);
    }
  };
  */

  const loadCustomers = async () => {
    setApiErrors('');
    setLoading(true);
    try {
      const response = await UserService.getCustomersADM(); // Replace with your API call to fetch customers
      setCustomers(response.data); // Assuming response.data contains an array of customers
    } catch (error) {
      setApiErrors('Kunden konnten nicht geladen werden');
    } finally {
      setLoading(false);
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // Reset to the first page when searching
  };

  const handleSortChange = (field) => {
    const newSortOrder = sortField === field && sortOrder === 'asc' ? 'desc' : 'asc';
    setSortField(field);
    setSortOrder(newSortOrder);
  };

  // Handle batch code selection for each checkbox in the row
  const toggleBatchCodeSelection = (batchCodeId) => {
    setSelectedBatchCodes((prevSelected) => 
      prevSelected.includes(batchCodeId) 
        ? prevSelected.filter((id) => id !== batchCodeId) 
        : [...prevSelected, batchCodeId]
    );
  };

  const openSaleModal = () => setModalIsOpen(true);
  const closeSaleModal = () => {
    setModalIsOpen(false);
    setSelectedBatchCodes([]); // Reset selection on close
    setFormData({ place_id: '', service_id: '', place_name: '', place_address: '', latitude: '', longitude: '' }); // Reset form data
    setSelectedCustomerId(''); // Reset selected customer on close
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    if (!value) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: `${name.replace('_', ' ')} is required.` }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: undefined }));
    }
  };

  const handleSale = async () => {
    try {
      if (!formData.place_id || !selectedCustomerId || !selectedTariffId) {
        setApiErrors('Bitte wählen Sie einen Ort und einen Kunden aus.');
        return;
      }
      const saleData = {
        tariff_id: selectedTariffId,
        place_id: formData.place_id,
        customer_id: selectedCustomerId,
        batch_codes: selectedBatchCodes,
        service_id: formData.service_id,
        place_name: formData.place_name,
        place_address: formData.place_address,
        latitude: formData.latitude,
        longitude: formData.longitude,
      };
      console.info('Sale Data:', saleData);
      await UserService.sellBatchCodes(saleData);
      setApiErrors(''); // Clear any previous errors
      alert('Chargecodes erfolgreich verkauft!');
      closeSaleModal(); // Close modal on success
      loadBatchCodes(); // Reload the list
    } catch (error) {
      setApiErrors('Failed to Chargecodes verkaufen.');
      console.error('Sale error:', error);
    }
  };

  const deselectAllBatchCodes = () => {
    setSelectedBatchCodes([]); // Clear all selected batch codes
  };

  useEffect(() => {
    if (modalIsOpen && inputRef.current) {
      inputRef.current.focus();
    }
    

  }, [modalIsOpen]);

  const onLoad = (mapInstance) => {
    setMap(mapInstance);
  };

  const onUnmount = () => {
    setMap(null);
  };

  const onLoadAutocomplete = (autocompleteInstance) => {
    setAutocomplete(autocompleteInstance);
  };

  const onPlaceChanged = () => {
    if (autocomplete !== null) {
      const place = autocomplete.getPlace();
      if (!place.geometry || !place.geometry.location) {
        return;
      }

      setMarkerPosition(place.geometry.location);
      setPlaceInfo({
        placeId: place.place_id,
        name: place.name,
        address: place.formatted_address,
      });
      console.log(place);
      console.log(place.place_id);
      console.log(place.name);
      console.log(place.formatted_address);
      if (place.geometry.viewport) {
        map.fitBounds(place.geometry.viewport);
      } else {
        map.setCenter(place.geometry.location);
        map.setZoom(17);
      }
      
      // Set formData values from the place
     
      setFormData({
        place_id: place.place_id,
        place_name: place.name,
        place_address: place.formatted_address,
        latitude: place.geometry.location.lat(),
        longitude: place.geometry.location.lng(),
      
      });
      console.log("Palce:"+formData.place_id);
      console.log("Palce2:"+formData.formatted_address);
      setIsInfoWindowOpen(true);
    }
  };

  return (
    <Container>
      <h1>Chargecode-Verwaltung</h1>
      {apiErrors && <Alert variant="danger">{apiErrors}</Alert>}

      <Form.Group controlId="searchBatchCode">
        <Form.Label>Chargecodes durchsuchen</Form.Label>
        <Form.Control
          type="text"
          placeholder="Suche in allen Spalten"
          value={searchTerm}
          onChange={handleSearchChange}
          aria-label="Chargecodes in allen Spalten suchen"
          style={{ minHeight: 44 }}
        />
      </Form.Group>

      <div className="d-flex flex-wrap gap-3 mt-3 mb-3">
        <SearchableFilter
          label="Chargenname"
          value={batchNameFilter}
          onChange={(next) => { setBatchNameFilter(next); setCurrentPage(1); }}
          placeholder="Chargenname filtern"
          options={(filterOptions.batchNames || []).map((name) => ({ value: name, label: name }))}
        />
        <SearchableFilter
          label="Käufer"
          value={buyerFilter}
          onChange={(next) => { setBuyerFilter(next); setCurrentPage(1); }}
          placeholder="Käufer filtern"
          options={(filterOptions.buyers || []).map((buyer) => ({
            value: String(buyer.id),
            label: buyer.name ? `${buyer.name} (${buyer.id})` : String(buyer.id),
          }))}
        />
        <SearchableFilter
          label="Verkäufer"
          value={sellerFilter}
          onChange={(next) => { setSellerFilter(next); setCurrentPage(1); }}
          placeholder="Verkäufer filtern"
          options={(filterOptions.sellers || []).map((seller) => ({
            value: String(seller.id),
            label: seller.name ? `${seller.name} (${seller.id})` : String(seller.id),
          }))}
        />
      </div>

      <Button variant="primary" onClick={openSaleModal} disabled={selectedBatchCodes.length === 0} className="me-2 mb-2" style={{ minHeight: 44 }}>
        Verkaufen ({selectedBatchCodes.length} ausgewählt)
      </Button>
      <Button variant="secondary" onClick={deselectAllBatchCodes} disabled={selectedBatchCodes.length === 0} className="mb-2" style={{ minHeight: 44 }}>
        Alle abwählen
      </Button>

      {loading && <Spinner animation="border" />}
      
      <div className="table-responsive">
      <Table striped bordered hover className="mt-3">
    <thead>
      <tr>
        <th onClick={() => handleSortChange('batch_code_id')} style={{ cursor: 'pointer' }}>ID</th>
        <th onClick={() => handleSortChange('batch_name')} style={{ cursor: 'pointer' }}>Chargenname</th>
        <th onClick={() => handleSortChange('batch_id')} style={{ cursor: 'pointer' }}>Chargen-ID</th>
        <th onClick={() => handleSortChange('lfd_nr')} style={{ cursor: 'pointer' }}>LfdNr.</th>
        <th onClick={() => handleSortChange('batch_date')} style={{ cursor: 'pointer' }}>Chargendatum</th>
        <th onClick={() => handleSortChange('batch_quantity')} style={{ cursor: 'pointer' }}>Menge</th>
        <th onClick={() => handleSortChange('buyer_id')} style={{ cursor: 'pointer' }}>Käufer-ID</th>
        <th onClick={() => handleSortChange('buyer_name')} style={{ cursor: 'pointer' }}>Käufername</th>
        <th onClick={() => handleSortChange('seller_id')} style={{ cursor: 'pointer' }}>Verkäufer-ID</th>
        <th onClick={() => handleSortChange('seller_name')} style={{ cursor: 'pointer' }}>Verkäufername</th>
        <th onClick={() => handleSortChange('qr_code')} style={{ cursor: 'pointer' }}>QR-Code</th>
        <th onClick={() => handleSortChange('batch_validity_from_date')} style={{ cursor: 'pointer' }}>Gültig ab</th>
        <th onClick={() => handleSortChange('batch_validity_until_date')} style={{ cursor: 'pointer' }}>Gültig bis</th>
        <th>Select</th>
      </tr>
    </thead>
    <tbody>
      {batchCodes.length > 0 ? (
        batchCodes.map((code) => (
            <tr 
            key={code.batch_code_id} 
            style={code.sale_status === 'saled_to_customer' ? { backgroundColor: '#c3e6cb' } : {}} // Light Green Background
          >
            <td>{code.batch_code_id}</td>
            <td>{code.batch_name || '–'}</td>
            <td>{code.batch_id || '–'}</td>
            <td>{code.lfd_nr != null ? code.lfd_nr : '–'}</td>
            <td style={{ whiteSpace: 'nowrap' }}>{formatDeDate(code.batch_date)}</td>
            <td>{code.batch_quantity}</td>
            <td>{code.buyer_id != null ? code.buyer_id : '–'}</td>
            <td>{code.buyer_name || '–'}</td>
            <td>{code.seller_id != null ? code.seller_id : '–'}</td>
            <td>{code.seller_name || '–'}</td>
            <td>
          {/* Check if qrCode exists and render as image */}
          {code.qr_code ? (
            <button
              type="button"
              onClick={() => {
                if (code.sale_status === 'saled_to_customer') {
                  const reviewUrl = googleReviewUrl(code);
                  if (reviewUrl) {
                    window.open(reviewUrl, '_blank', 'noopener,noreferrer');
                    return;
                  }
                }
                navigate(`/demobatches?activate=${code.batch_code_id}`);
              }}
              title={code.sale_status === 'saled_to_customer' ? 'Google-Bewertung des Unternehmens öffnen' : 'Zur Demo-Freigabe'}
              aria-label={code.sale_status === 'saled_to_customer' ? 'Google-Bewertung des Unternehmens öffnen' : 'QR-Code zur Demo-Freigabe öffnen'}
              style={{ border: 0, background: "transparent", padding: 0, minWidth: 44, minHeight: 44 }}
            >
              <img
                src={`data:image/png;base64,${code.qr_code}`}
                alt="QR Code"
                style={{ width: '100px', height: '100px' }}
              />
            </button>
          ) : (
            'Kein QR-Code verfügbar'
          )}
        </td>
            <td style={{ whiteSpace: 'nowrap' }}>{formatDeDate(code.batch_validity_from_date)}</td>
            <td style={{ whiteSpace: 'nowrap' }}>{formatDeDate(code.batch_validity_until_date)}</td>
            <td className="text-center align-middle" style={{ minWidth: 72 }}>
              {code.sale_status === 'saled_to_customer' ? (
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>An Kunden verkauft</Tooltip>}
                >
                  <span><FaCheckCircle style={{ color: 'green' }} aria-label="An Kunden verkauft" /></span>
                </OverlayTrigger>
              ) : (
                <input
                  type="checkbox"
                  checked={selectedBatchCodes.includes(code.batch_code_id)}
                  onChange={() => toggleBatchCodeSelection(code.batch_code_id)}
                  aria-label="Code auswählen"
                  style={{ width: 22, height: 22, margin: 0, verticalAlign: "middle" }}
                />
              )}
            </td>
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan="14" className="text-center">Keine Chargecodes gefunden.</td>
        </tr>
      )}
    </tbody>
  </Table>
      </div>

      <Pagination>
        {[...Array(totalPages)].map((_, index) => (
          <Pagination.Item 
            key={index} 
            active={index + 1 === currentPage} 
            onClick={() => setCurrentPage(index + 1)}>
            {index + 1}
          </Pagination.Item>
        ))}
      </Pagination>

      {/* Sale Modal */}
      <Modal show={modalIsOpen} onHide={closeSaleModal}>
        <Modal.Header closeButton>
          <Modal.Title>Ort und Kunden für Verkauf auswählen</Modal.Title>
        </Modal.Header>
        <Modal.Body>
         
        <Form.Group controlId="selectCustomer">
            <Form.Label>Kunde auswählen</Form.Label>
            <Form.Control 
              as="select" 
              value={selectedCustomerId} 
              onChange={(e) => setSelectedCustomerId(e.target.value)} 
            >
              <option value="">Kunden auswählen</option>
              {customers.map((customer) => (
                <option key={customer.customer_id} value={customer.customer_id}>{customer.custumer_company_name}</option>
              ))}
            </Form.Control>
          </Form.Group>

          <Form.Group controlId="formSubVo">
        <Form.Label>Tarif auswählen</Form.Label>
        <Form.Control
          as="select" 
          value={selectedTariffId} 
          onChange={(e) => setSelectedTariffId(e.target.value)} 
        >
          <option value="">Select Tariff</option>
          {tariffs.map(mvos => (
            <option key={mvos.tariff_id} value={mvos.tariff_id}>
              {mvos.tariff_name}
            </option>
          ))}
          </Form.Control>
        <Form.Control.Feedback type="invalid">
                {errors.tariff_id}
              </Form.Control.Feedback>
              
              </Form.Group>
         
          <Form.Group controlId="formAreaGroupName">
            <Form.Label>Ort-ID(z.B. GooglePlaceID...)</Form.Label>
            <Form.Control
              type="text"
              placeholder="Ort-ID eingeben"
              name="place_id"
              value={formData.place_id}
              onChange={handleChange}
              onBlur={handleBlur}
              isInvalid={!!errors.place_id}
              readOnly
            />
            <Form.Control.Feedback type="invalid">
              {errors.place_id}
            </Form.Control.Feedback>
          </Form.Group>

          

          <Form.Group controlId="formPlaceName">
            <Form.Label>Ortsname</Form.Label>
            <Form.Control
              type="text"
              name="place_name"
              value={formData.place_name}
              onChange={handleChange}
              onBlur={handleBlur}
              readOnly
            />
          </Form.Group>

          <Form.Group controlId="formPlaceAddress">
            <Form.Label>Ortsadresse</Form.Label>
            <Form.Control
              type="text"
              name="place_address"
              value={formData.place_address}
              onChange={handleChange}
              onBlur={handleBlur}
              readOnly
            />
          </Form.Group>

          {/* Hidden fields to store place_id, place_name, and address */}
          <Form.Control type="hidden" name="place_name" value={formData.place_name} />
          <Form.Control type="hidden" name="place_address" value={formData.place_address} />
          <Form.Control type="hidden" name="latitude" value={formData.latitude} />
          <Form.Control type="hidden" name="longitude" value={formData.longitude} />



          <LoadScript googleMapsApiKey={apiKey} libraries={libraries}>
            <GoogleMap
              mapContainerStyle={mapContainerStyle}
              center={markerPosition || { lat: -34.397, lng: 150.644 }} // Default center
              zoom={13}
              onLoad={onLoad}
              onUnmount={onUnmount}
            >
              <div style={{ position: "absolute", top: 10, left: 10, zIndex: 5 }}>
                <Autocomplete
                  onLoad={onLoadAutocomplete}
                  onPlaceChanged={onPlaceChanged}
                >
                  <input
                    id="pac-input"
                    className="controls"
                    type="text"
                    placeholder="Ort eingeben"
                    ref={inputRef}
                    style={{ width: '400px', height: '40px', padding: '0 10px' }}
                  />
                </Autocomplete>
              </div>

              {markerPosition && isInfoWindowOpen && (
  <InfoWindow
    position={markerPosition}
    onCloseClick={() => setIsInfoWindowOpen(false)}
  >
    <div>
      <strong>{placeInfo.name}</strong>
      <br />
      <span>{placeInfo.address}</span>
    </div>
  </InfoWindow>
)}
            </GoogleMap>
          </LoadScript>

          <style>{`
            .pac-container {
              z-index: 10000 !important; /* Ensure dropdown appears above modal */
            }
          `}</style>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeSaleModal}>
            Schließen
          </Button>
          <Button variant="primary" onClick={handleSale}>
            Chargecodes verkaufen
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default BatchCodeManager;
